import { type FetchResponse, ofetch } from "ofetch";
import { toast } from "sonner";
import { envVars } from "../env/schema";
import type { APIResponse } from "./types";

export const api = ofetch.create({
	baseURL: `${envVars.VITE_API_URL}/v1`,
	headers: {
		"Content-Type": "application/json",
	},
	async onRequest({ options }) {
		// Add auth token if available
		const token = localStorage.getItem("auth_token");
		if (token) {
			const headers = new Headers(options.headers);
			headers.set("Authorization", `Bearer ${token}`);
			options.headers = headers;
		}

		// Don't set Content-Type if body is FormData
		if (options.body instanceof FormData) {
			const headers = new Headers(options.headers);
			headers.delete("Content-Type");
			options.headers = headers;
		}
	},
	async onResponseError({
		response,
	}: { response: FetchResponse<APIResponse> }) {
		// Handle common error cases
		if (response.status === 401) {
			localStorage.removeItem("auth_token");
			// window.location.href = "/login";
		}
		if (response.status === 400) {
			toast.error("Bad Request", {
				description:
					response._data?.message || "Please check your input and try again.",
			});
		}
		// if (response.status === 404) {
		// 	toast.error("Not Found", {
		// 		description:
		// 			response._data?.message ||
		// 			"The resource you are looking for does not exist.",
		// 	});
		// }
		if (response.status === 422) {
			toast.error("Unprocessable Entity", {
				description:
					response._data?.message ||
					"The resource you are looking for is unprocessable.",
			});
		}
		if (response.status === 500) {
			toast.error("Internal Server Error", {
				description:
					response._data?.message || "An internal server error occurred.",
			});
		}
	},
});
